import TranslatorButton from './TranslatorButton';

export default TranslatorButton;